export enum FieldName {
  token = 'token',
  name = 'name',
  password = 'password',
  hostURL = 'hostURL',
  clientId = 'clientId',
  secretKey = 'secretKey',
  awsRoleArn = 'awsRoleArn',
  awsExternalId = 'awsExternalId',
  awsAccessKey = 'awsAccessKey',
  awsAccessSecret = 'awsAccessSecret',
  tenant = 'tenant',
}

export enum CredentialsType {
  UserPassword = 'UserPassword',
  Token = 'Token',
  TokenAndUser = 'TokenAndUser',
  IdentityProvider = 'IdentityProvider',
  ClientIdSecretKey = 'ClientIdSecretKey',
  AWSAssumeRole = 'AWSAssumeRole',
  AWSAssumeRoleCloudFormation = 'AWSAssumeRoleCloudFormation',
  AWSOrganizationConnection = 'AWSOrganizationConnection',
  AWSAssumeRoleOnprem = 'AWSAssumeRoleOnprem',
  AWSAssumeRoleCloudFormationOnprem = 'AWSAssumeRoleCloudFormationOnprem',
  AWSOrganizationConnectionOnprem = 'AWSOrganizationConnectionOnprem',
  UserPasswordAndTenant = 'UserPasswordAndTenant',
  None = 'None',
  ApiKey = 'ApiKey',
}

export const CredentialsTypeTitle = {
  [CredentialsType.UserPassword]: 'User Name & Password',
  [CredentialsType.Token]: 'Token',
  [CredentialsType.TokenAndUser]: 'User Name & Token',
  [CredentialsType.IdentityProvider]: 'Identity Provider',
  [CredentialsType.ClientIdSecretKey]: 'Access keys',
  [CredentialsType.AWSAssumeRoleCloudFormation]: 'Automatic',
  [CredentialsType.AWSOrganizationConnection]: 'Organization',
  [CredentialsType.AWSAssumeRole]: 'Manual',
  [CredentialsType.AWSAssumeRoleCloudFormationOnprem]: 'Automatic',
  [CredentialsType.AWSOrganizationConnectionOnprem]: 'Organization',
  [CredentialsType.AWSAssumeRoleOnprem]: 'Manual',
  [CredentialsType.UserPasswordAndTenant]: 'Credentials',
  [CredentialsType.ApiKey]: 'Apikey',
};
